// extracted by mini-css-extract-plugin
export default {"SwitchViewModeContainer":"SwitchViewMode_SwitchViewModeContainer__gobyi"};